import React from 'react';
import Select from 'react-select';
import FormControl from 'react-bootstrap/FormControl';

import FieldController from '../../../controller/FieldController';
import Filter from '../../filter/FilterPannel';

import FieldCity from '../../common/FieldCity';
import FieldState from '../../common/FieldState';
import FieldCountry from '../../common/FieldCountry';
import Display from '../../../util/Display';

class AutomationAssigmnentItem extends React.Component {

  constructor(props) {
    super(props);
    this.state = { index: props.index, field: props.value.field, value: props.value.value };
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ index: props.index, field: props.value.field, value: props.value.value });
  }

  fieldChange = field => {
    this.setState({ ...this.state, field: field });
    this.props.onEdit(this.state.index, { field: field.value, value: '' });
  }
  handleTextChange = value => {
    this.setState({ ...this.state, value: value });
    this.props.onEdit(this.state.index, { field: this.state.field.value, value });
  }
  valueChange = select => {
    this.setState({ ...this.state, value: select });
    this.props.onEdit(this.state.index, {field: this.state.field.value, value: select.value});
  }
  
  render() {
    let isText = false;
    let isCity = false;
    let isState = false;
    let isCountry = false;
    let options = [];
    if(this.state.field !== null && this.state.field !== undefined) {
      isText = FieldController.showTextFilter(this.state.field.type, Filter.Equals);
      isCity = FieldController.showCity(this.state.field.type, this.state.condition);
      isState = FieldController.showState(this.state.field.type, this.state.condition);
      isCountry = FieldController.showCountry(this.state.field.type, this.state.condition);
      
      if(this.state.field !== '' && !isText && !isCity && !isState && !isCountry) {
        options = FieldController.getOptions(
          this.props.model.fields[this.state.field.value]);
      }
    }

    return (
      <div className="formhead col-md-12">
        <div className="row">
          <div className="col-md-4">
            <Select value={this.state.field} onChange={this.fieldChange}
              options={this.props.fields} isSearchable={true} />
          </div>
          <div className="col-md-4">
            { isText &&
              <FormControl type="text" placeholder="Value" value={this.state.value}
                onChange={ event => this.handleTextChange(event.target.value) } />
            }
            
            { !isText && !isCity && !isState && !isCountry &&
              <Select value={this.state.value} onChange={this.valueChange}
                options={options} isSearchable={true} />
            }

            { isCity && <FieldCity defaultValue={this.state.value} onCitySelected={this.valueChange} /> }
            { isState && <FieldState defaultValue={this.state.value} onStateSelected={this.valueChange}/>}
            { isCountry && <FieldCountry defaultValue={this.state.value} onSelected={this.valueChange} /> }
          </div>
          { Display.MultiAction(this.state.index, this.props.onAdd, this.props.onDelete) }   
        </div>    
      </div>
    );
  }
}
export default AutomationAssigmnentItem;